export type VirusStatus =
  | 'to_be_scanned'
  | 'no_virus_detected'
  | 'scanning'
  | 'virus_detected'
  | 'errored'
  | 'skipped';

// Only a confirmed detection withholds the file. The other non-clean states — a scan still
// running, one that errored, one skipped because the file is over
// `PersonAttachment::MAX_FILE_SIZE_FOR_VIRUS_SCAN` — are surfaced as a warning, the way the
// candidate profile's preview modal does, rather than making the document unreachable.
export const isVirusDetected = (status?: VirusStatus | string | null) =>
  status === 'virus_detected';

// Key under `shared.document_preview.virus_warning`, or null when there is nothing to say.
export const virusWarningKey = (status?: VirusStatus | string | null) => {
  if (!status || status === 'no_virus_detected') {
    return null;
  }

  return status === 'to_be_scanned' ? 'scanning' : status;
};
